import bookingApi from './bookingApi';
import {
  ProductResponseType,
  ReservationPayload,
} from 'types/ProductReservationType';
import {
  CreateBookingApiResponse,
  createBookingTypes,
} from 'types/CreateBooking';
import {
  BookingResponse,
  bookingStatusResponse,
} from 'types/BookingConfirmation';
import { VehicleResponse } from 'types/products';
import { BookingDetailResponse } from 'types/BookingDetails';
import { SearchPayload, SearchResponse } from 'types/searchPayload';
export const validateBranchWithLive = async (
  payload: SearchPayload
): Promise<SearchResponse> => {
  const { data } = await bookingApi.post<SearchResponse>(
    `/booking/search`,
    payload
  );
  return data;
};

export const bookingReservation = async (
  payload: ReservationPayload
): Promise<ProductResponseType> => {
  const response = await bookingApi.post<ProductResponseType>(
    `/booking/reservation?countryCode=${process.env.REACT_APP_API_COUNTRY_CODE}`,
    payload
  );
  return response.data;
};

export const createBooking = async (
  payload: createBookingTypes
): Promise<CreateBookingApiResponse> => {
  const response = await bookingApi.post<CreateBookingApiResponse>(
    `/booking/create`,
    payload
  );
  return response.data;
};

export const getVehicles = async (id: string): Promise<VehicleResponse> => {
  const response = await bookingApi.get<VehicleResponse>(
    `/booking/listing?id=${id}`
  );
  return response.data;
};
export const getBooking = async (
  bookingId: string
): Promise<BookingResponse> => {
  const response = await bookingApi.get<BookingResponse>(
    `/booking/${bookingId}`
  );
  return response.data;
};

export const getBookingDetail = async (
  id: string,
  vId: string
): Promise<BookingDetailResponse> => {
  const response = await bookingApi.get<BookingDetailResponse>(
    `/booking/detail/?id=${id}&vid=${vId}`
  );
  return response.data;
};

export const getBookingStatus = async (
  bookingId: string
): Promise<bookingStatusResponse> => {
  const response = await bookingApi.get<bookingStatusResponse>(
    `/booking/status/${bookingId}`
  );
  return response.data;
};
